class RcProductTitle extends HTMLElement {
  
  constructor() {
    super();
    this.event;
  };

  connectedCallback() { this.initialize(); };

  disconnectedCallback() { this.deinitialize(); };

  onVariantChange = (event) => {
    const variantData = event.detail.data;
    if(!variantData) return;
    
    // Update page title if data attribute is present
    const titleElement = this.getTitle;
    if(titleElement) {
      const primaryTitle = variantData.option1 || variantData.title || titleElement.textContent;
      titleElement.textContent = primaryTitle;
    }

    // Update wishlist button variant data
    const wishlistBtn = this.querySelector('[data-gw-variant-id]');
    if (wishlistBtn) {
      wishlistBtn.setAttribute('data-gw-variant-id', variantData.id);
    }
  };

  initialize() { 
    this.event = window.umbrellaConfig.events.variantChange;
    document.addEventListener(this.event, this.onVariantChange);
  };
  
  deinitialize() { 
    document.removeEventListener(this.event, this.onVariantChange); 
  };

};

if(!customElements.get('rc-product-title')) customElements.define('rc-product-title', RcProductTitle);